import AsyncSelect from 'react-select/async'
import debounce from 'debounce-async'
import { useMemo } from 'react'
import axios from 'axios'
import { Get_GamingHardware } from '../../../../api/api'

const HardwareSelect = ({ type, placeholder, value, onChange, isMulti = false }) => {
  const loadOptions = useMemo(() => {
    return debounce(async (inputValue) => {
      if (!inputValue?.trim()) return []

      const { data } = await axios.get(Get_GamingHardware(type, inputValue.trim()))

      return data.map((item) => ({
        value: item.id,
        label: item.displayTitle || item.model,
      }))
    }, 300)
  }, [type])

  return (
    <AsyncSelect
      cacheOptions
      placeholder={placeholder}
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      isClearable
      isMulti={isMulti}
      isRtl
      openMenuOnFocus={false}
      noOptionsMessage={({ inputValue }) =>
        inputValue?.trim() ? 'موردی یافت نشد' : 'برای جستجو تایپ کنید'
      }
      loadingMessage={() => 'لطفا صبر کنید...'}
    />
  )
}

export default HardwareSelect
